//This is that little grey, uppercase text li nuzaw bhala labels ghal kollox (use for forms aswell)

export default function SectionLabel({ children, htmlFor, className = "", }) {

    if (htmlFor) {
        return (
            <label htmlFor={htmlFor} className={` truncate mb-1 text-xs font-semibold uppercase tracking-widest text-gray-500 ${className}`}>
                {children}
            </label>
        );
    }

    return <p className={`truncate mb-1 text-xs font-semibold uppercase tracking-widest text-gray-500 ${className}`}>
        {children}
    </p>;
}